(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@babel/runtime/helpers/esm/slicedToArray'), require('@babel/runtime/helpers/esm/objectSpread'), require('@babel/runtime/helpers/esm/objectWithoutProperties'), require('@babel/runtime/helpers/esm/classCallCheck'), require('@babel/runtime/helpers/esm/createClass'), require('@babel/runtime/helpers/esm/defineProperty'), require('@babel/runtime/helpers/esm/construct'), require('@babel/runtime/helpers/esm/toConsumableArray'), require('@babel/runtime/helpers/esm/typeof'), require('json-stringify-safe'), require('@babel/runtime/regenerator'), require('@babel/runtime/helpers/esm/asyncToGenerator'), require('@babel/runtime/helpers/esm/possibleConstructorReturn'), require('@babel/runtime/helpers/esm/getPrototypeOf'), require('@babel/runtime/helpers/esm/get'), require('@babel/runtime/helpers/esm/inherits'), require('@tencent/im-wang'), require('eventemitter3'), require('@tencent/edu-reportor'), require('uuid/v4')) :
	typeof define === 'function' && define.amd ? define(['exports', '@babel/runtime/helpers/esm/slicedToArray', '@babel/runtime/helpers/esm/objectSpread', '@babel/runtime/helpers/esm/objectWithoutProperties', '@babel/runtime/helpers/esm/classCallCheck', '@babel/runtime/helpers/esm/createClass', '@babel/runtime/helpers/esm/defineProperty', '@babel/runtime/helpers/esm/construct', '@babel/runtime/helpers/esm/toConsumableArray', '@babel/runtime/helpers/esm/typeof', 'json-stringify-safe', '@babel/runtime/regenerator', '@babel/runtime/helpers/esm/asyncToGenerator', '@babel/runtime/helpers/esm/possibleConstructorReturn', '@babel/runtime/helpers/esm/getPrototypeOf', '@babel/runtime/helpers/esm/get', '@babel/runtime/helpers/esm/inherits', '@tencent/im-wang', 'eventemitter3', '@tencent/edu-reportor', 'uuid/v4'], factory) :
	(global = global || self, factory(global.imlog = {}, global._slicedToArray, global._objectSpread, global._objectWithoutProperties, global._classCallCheck, global._createClass, global._defineProperty, global._construct, global._toConsumableArray, global._typeof, global.stringify, global._regeneratorRuntime, global._asyncToGenerator, global._possibleConstructorReturn, global._getPrototypeOf, global._get, global._inherits, global.imWang, global.EventEmitter, global.reportor, global.uuid));
}(this, function (exports, _slicedToArray, _objectSpread, _objectWithoutProperties, _classCallCheck, _createClass, _defineProperty, _construct, _toConsumableArray, _typeof, stringify, _regeneratorRuntime, _asyncToGenerator, _possibleConstructorReturn, _getPrototypeOf, _get, _inherits, imWang, EventEmitter, reportor, uuid) { 'use strict';

	_slicedToArray = _slicedToArray && _slicedToArray.hasOwnProperty('default') ? _slicedToArray['default'] : _slicedToArray;
	_objectSpread = _objectSpread && _objectSpread.hasOwnProperty('default') ? _objectSpread['default'] : _objectSpread;
	_objectWithoutProperties = _objectWithoutProperties && _objectWithoutProperties.hasOwnProperty('default') ? _objectWithoutProperties['default'] : _objectWithoutProperties;
	_classCallCheck = _classCallCheck && _classCallCheck.hasOwnProperty('default') ? _classCallCheck['default'] : _classCallCheck;
	_createClass = _createClass && _createClass.hasOwnProperty('default') ? _createClass['default'] : _createClass;
	_defineProperty = _defineProperty && _defineProperty.hasOwnProperty('default') ? _defineProperty['default'] : _defineProperty;
	_construct = _construct && _construct.hasOwnProperty('default') ? _construct['default'] : _construct;
	_toConsumableArray = _toConsumableArray && _toConsumableArray.hasOwnProperty('default') ? _toConsumableArray['default'] : _toConsumableArray;
	_typeof = _typeof && _typeof.hasOwnProperty('default') ? _typeof['default'] : _typeof;
	stringify = stringify && stringify.hasOwnProperty('default') ? stringify['default'] : stringify;
	_regeneratorRuntime = _regeneratorRuntime && _regeneratorRuntime.hasOwnProperty('default') ? _regeneratorRuntime['default'] : _regeneratorRuntime;
	_asyncToGenerator = _asyncToGenerator && _asyncToGenerator.hasOwnProperty('default') ? _asyncToGenerator['default'] : _asyncToGenerator;
	_possibleConstructorReturn = _possibleConstructorReturn && _possibleConstructorReturn.hasOwnProperty('default') ? _possibleConstructorReturn['default'] : _possibleConstructorReturn;
	_getPrototypeOf = _getPrototypeOf && _getPrototypeOf.hasOwnProperty('default') ? _getPrototypeOf['default'] : _getPrototypeOf;
	_get = _get && _get.hasOwnProperty('default') ? _get['default'] : _get;
	_inherits = _inherits && _inherits.hasOwnProperty('default') ? _inherits['default'] : _inherits;
	EventEmitter = EventEmitter && EventEmitter.hasOwnProperty('default') ? EventEmitter['default'] : EventEmitter;
	reportor = reportor && reportor.hasOwnProperty('default') ? reportor['default'] : reportor;
	uuid = uuid && uuid.hasOwnProperty('default') ? uuid['default'] : uuid;

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var utils = createCommonjsModule(function (module, exports) {
	  var isType = function isType(type) {
	    return function (x) {
	      return Object.prototype.toString.call(x) === "[object ".concat(type, "]");
	    };
	  };

	  exports.isString = isType('String');
	  exports.isNumber = isType('Number');
	  exports.isFunction = isType('Function');
	  exports.isUndefined = isType('Undefined');
	  exports.isObject = isType('Object');
	  var isArray = isType('Array');
	  exports.isArray = isArray;
	  exports.isError = isType('Error');
	  exports.isServer = typeof document === 'undefined';
	  exports.isBrowser = typeof document !== 'undefined';

	  exports.singletonify = function (Klass) {
	    var instance;
	    return function () {
	      if (!instance) {
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }

	        instance = _construct(Klass, args);
	      }

	      return instance;
	    };
	  };

	  exports.replacers = function (k, v) {
	    if (v instanceof Error) {
	      var r = {};
	      Object.getOwnPropertyNames(v).forEach(function (n) {
	        r[n] = v[n];
	      });
	      return r;
	    }

	    return v;
	  };

	  exports.camel2snake = function (s) {
	    return s.replace(/[A-Z]/g, '_$&').toLowerCase();
	  };

	  exports.camelkeys2snake = function (o) {
	    var result = {};
	    Object.keys(o).forEach(function (k) {
	      result[exports.camel2snake(k)] = o[k];
	    });
	    return result;
	  };

	  exports.pick = function (obj, arr) {
	    obj = Object(obj);
	    var o = {};
	    arr.forEach(function (item) {
	      if (item in obj) {
	        o[item] = obj[item];
	      }
	    });
	    return o;
	  };

	  exports.union = function (arr1, arr2) {
	    if (isArray(arr1) && isArray(arr2)) {
	      var temp = arr1.concat(arr2);
	      return temp.filter(function (item, index) {
	        return temp.indexOf(item, 0) === index;
	      });
	    }
	  };
	  /**
	   * 清洗上报数据中不符合类型的key值
	   * @param {object} obj
	   */


	  exports.clean = function (obj) {
	    obj = Object(obj);
	    var o = {};
	    Object.keys(obj).forEach(function (k) {
	      var v = obj[k];

	      if (v !== undefined && v !== null && v !== '') {
	        o[k] = exports.isString(v) || exports.isNumber(v) ? v : v.toString();
	      }
	    });
	    return o;
	  };
	});
	var utils_1 = utils.isString;
	var utils_2 = utils.isNumber;
	var utils_3 = utils.isFunction;
	var utils_4 = utils.isUndefined;
	var utils_5 = utils.isObject;
	var utils_6 = utils.isArray;
	var utils_7 = utils.isError;
	var utils_8 = utils.isServer;
	var utils_9 = utils.isBrowser;
	var utils_10 = utils.singletonify;
	var utils_11 = utils.replacers;
	var utils_12 = utils.camel2snake;
	var utils_13 = utils.camelkeys2snake;
	var utils_14 = utils.pick;
	var utils_15 = utils.union;
	var utils_16 = utils.clean;

	var consts = createCommonjsModule(function (module, exports) {
	  var camel2snake = utils.camel2snake,
	      union = utils.union;
	  exports.Types = {
	    trace: 'trace',
	    debug: 'debug',
	    info: 'info',
	    warn: 'warn',
	    error: 'error',
	    fatal: 'fatal',
	    monitor: 'monitor',
	    speed: 'speed',
	    pageSpeed: 'pageSpeed'
	  };
	  exports.Levels = {
	    trace: 10,
	    debug: 20,
	    info: 30,
	    warn: 40,
	    error: 50,
	    fatal: 60
	  };
	  exports.EnvMap = {
	    development: 'dev',
	    production: 'prod',
	    dev: 'dev',
	    prod: 'prod',
	    test: 'test',
	    pre: 'pre',
	    grey: 'grey'
	  };
	  exports.camelPreserveKeys = ['logTimestamp', 'source', 'level', 'env', 'bizId', 'uin', 'uid', 'project', 'type', 'url', 'cmd', 'traceId', 'clientIp', 'clientName', 'serverIp', 'serverName', 'serviceIp', 'remoteIp', 'remoteName', 'resultFlag', 'protocol', 'domain', 'pathname', 'query', 'method', 'headers', 'body', 'retcode', 'monitorId', 'monitorType', 'monitorCount', 'wangAppid', 'statusCode', 'costTime', 'userAgent', 'message', 'addition', 'addition1', 'channel', 'platform', 'pid', 'referer'];
	  exports.snakePreserveKeys = exports.camelPreserveKeys.map(function (x) {
	    return camel2snake(x);
	  });
	  exports.preserveKeys = union(exports.camelPreserveKeys, exports.snakePreserveKeys);
	  /* eslint-disable no-nested-ternary, no-restricted-globals */

	  exports.Window = typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};
	  /* eslint-enable no-nested-ternary, no-restricted-globals */
	});
	var consts_1 = consts.Types;
	var consts_2 = consts.Levels;
	var consts_3 = consts.EnvMap;
	var consts_4 = consts.camelPreserveKeys;
	var consts_5 = consts.snakePreserveKeys;
	var consts_6 = consts.preserveKeys;
	var consts_7 = consts.Window;

	/**
	 * Monitor类 - 实现monitor上报
	 */

	var Monitor =
	/*#__PURE__*/
	function () {
	  /**
	   * 创建Monitor实例
	   * @param {Object} options
	   * @param {Model} options.model
	   * @param {Pool} options.pool
	   */
	  function Monitor(_ref) {
	    var model = _ref.model,
	        pool = _ref.pool;

	    _classCallCheck(this, Monitor);

	    this.model = model;
	    this.pool = pool;
	  }
	  /**
	   * 上报一次id，如id为数字则会转发到monitor平台
	   * {@link http://monitor.server.com/}
	   * @example
	   * imlog.pv('user_index_plan');
	   * imlog.pv(302937);
	   * @param {string|number} id monitor监控点
	   */


	  _createClass(Monitor, [{
	    key: "pv",
	    value: function pv(id) {
	      this.monitor(id, 1);
	    }
	    /**
	     * 上报id，支持设置次数，如id为数字则会转发到monitor平台
	     * {@link http://monitor.server.com/}
	     * @example
	     * imlog.monitor('renderFail', 2);
	     * imlog.monitor(302937, 2);
	     * @param {string|number} id monitor监控点
	     * @param {number} [count=1] 次数
	     */

	  }, {
	    key: "monitor",
	    value: function monitor(id) {
	      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	      var data = this.model.generateRow(consts_1.monitor, {
	        monitor_id: id,
	        monitor_count: count
	      });
	      this.pool.add(data);
	    }
	  }]);

	  return Monitor;
	}();

	var SECONDS_OF_DAY = 3600 * 12;
	/**
	 * 日志级别
	 * @readonly
	 * @enum {number}
	 * @memberof @tencent/imlog
	 */

	var LEVELS = {
	  trace: 10,
	  debug: 20,
	  info: 30,
	  warn: 40,
	  error: 50,
	  fatal: 60
	}; // 生成日志流水时允许设置的额外字段，方便聚合查询

	var EXTRA_KEYS = ['project', 'monitorId', 'monitor_id', 'monitorCount', 'monitor_count', 'retcode', 'costTime', 'cost_time', 'platform', 'addition', 'addition1'];
	var IMLOG_DB_NAME = 'IMLOG_LOGGER';
	var IMLOG_DB_VERSION = 1;
	var IMLOG_DB_INDEX_TS = 'log_timestamp';
	var IMLOG_DB_STORE_NAME = 'logs';
	var IMLOG_DB_STORES = _defineProperty({}, IMLOG_DB_STORE_NAME, {
	  options: {
	    autoIncrement: true
	  },
	  indexes: {
	    channel: ['channel', {
	      unique: false
	    }],
	    type: ['type', {
	      unique: false
	    }],
	    project: ['project', {
	      unique: false
	    }],
	    log_timestamp: ['log_timestamp', {
	      unique: false
	    }]
	  }
	});
	var isIndexedDBSupport = !!(window.indexedDB && window.IDBTransaction && window.IDBKeyRange);

	function makeExtra(extra) {
	  if (utils_5(extra)) {
	    return utils_14(extra, EXTRA_KEYS);
	  }

	  return {};
	}
	function makeMessage(level, channel, msg) {
	  return "".concat(new Date().toISOString(), " [").concat(channel, "] ").concat(level.toUpperCase(), ": ").concat(msg);
	}
	/**
	 * 老用法：
	 * makeRecord(..., 'test', data)
	 * makeRecord(..., new Error(), data)
	 * makeRecord(..., { msg: 'xxx', err: new Error() })
	 * 新用法：Browser侧用法对齐console，简单取message值，其余stringify放addition
	 * @ignore
	 * @param  {...any} args
	 */

	function makeRecord(level, channel, args) {
	  var msg = ''; // 上报消息

	  var fields = {}; // 上报附加数据

	  var filteredArgs = []; // 控制台原附加数据列表

	  for (var i = 0; i < args.length; i++) {
	    var x = args[i];

	    if (!x) {
	      continue; // eslint-disable-line no-continue
	    }

	    if (utils_1(x) || utils_2(x)) {
	      msg += x;
	    } else if (utils_5(x)) {
	      // 兼容老用法
	      if (!msg && typeof x.msg === 'string') {
	        msg = x.msg;
	      }

	      if (!msg && x.err instanceof Error) {
	        msg = x.err.message;
	      }

	      fields["arg".concat(i)] = x;
	      filteredArgs.push(x);
	    } else if (utils_6(x) || utils_7(x)) {
	      fields["arg".concat(i)] = x;
	      filteredArgs.push(x);
	    } else {
	      // 其他类型不管：Date, RegExp, Set, Map, Promise, Symbol, Function
	      filteredArgs.push(x);
	    }
	  }

	  return {
	    message: makeMessage(level, channel, msg),
	    extra: {
	      addition: Object.keys(fields).length ? stringify(fields, utils_11) : undefined
	    },
	    filteredArgs: filteredArgs
	  };
	} // 规避uglifyjs干掉console

	var aliasLog = console;

	var noop = function noop() {};

	aliasLog.warn = aliasLog.warn || noop;
	aliasLog.debug = aliasLog.debug || noop;
	aliasLog.error = aliasLog.error || noop;
	aliasLog.log = aliasLog.log || noop; // https://en.wikipedia.org/wiki/ANSI_escape_code

	var colors = {
	  grey: 'rgb(129,131,131)',
	  cyan: 'rgb(51,187,200)',
	  green: 'rgb(37,188,36)',
	  yellow: 'rgb(173,173,39)',
	  red: 'rgb(194,54,33)',
	  magenta: 'rgb(211,56,211)'
	};

	var getColorStyle = function getColorStyle(x) {
	  return "color: ".concat(x);
	};

	var Styles = {
	  TRACE: getColorStyle(colors.grey),
	  DEBUG: getColorStyle(colors.cyan),
	  INFO: getColorStyle(colors.green),
	  WARN: getColorStyle(colors.yellow),
	  ERROR: getColorStyle(colors.red),
	  FATAL: getColorStyle(colors.magenta)
	};
	/**
	 * 输出到console
	 * @ignore
	 * @param {string} channel 频道
	 * @param {string} level 等级
	 * @param {string} message 日志内容
	 * @param {object} args 原参数
	 */

	function writeConsole(channel, level, message, args) {
	  var l = level.toUpperCase();
	  var msg = "%c".concat(message);
	  args.unshift('\n');

	  switch (l) {
	    case 'ERROR':
	    case 'FATAL':
	      aliasLog.log.apply(aliasLog, [msg, Styles[l]].concat(_toConsumableArray(args)));
	      break;

	    case 'WARN':
	      aliasLog.warn.apply(aliasLog, [msg, Styles[l]].concat(_toConsumableArray(args)));
	      break;

	    default:
	      aliasLog.debug.apply(aliasLog, [msg, Styles[l]].concat(_toConsumableArray(args)));
	  }
	}
	/**
	 * 加载脚本
	 * @ignore
	 * @param {string[]} urlArr 文件地址列表
	 * @param {function} callback
	 */

	function loadScript(urlArr, callback) {
	  callback = callback || function () {};

	  var scriptCount = 0;
	  var scriptError = 0;
	  var len = urlArr.length;

	  var onload = function onload() {
	    scriptCount++;

	    if (scriptCount === len) {
	      callback();
	    }
	  };

	  var onerror = function onerror(e) {
	    if (scriptError === 0) {
	      callback(e);
	    }

	    scriptError++;
	  };

	  var _loop = function _loop(i) {
	    var script = document.createElement('script');
	    script.type = 'text/javascript';

	    if (script.readyState) {
	      // IE
	      script.onreadystatechange = function () {
	        if (script.readyState === 'loaded' || script.readyState === 'complete') {
	          script.onreadystatechange = null;
	          onload();
	        }
	      };
	    } else {
	      // Others: Firefox, Safari, Chrome, and Opera
	      script.onload = onload;
	    }

	    script.onerror = onerror;
	    script.src = urlArr[i];
	    document.body.appendChild(script);
	  };

	  for (var i = 0; i < len; i++) {
	    _loop(i);
	  }
	}
	/**
	 * 转换日志对象到文件
	 * @ignore
	 * @param {object[]} logs 日志记录
	 */

	function transLogText(logs) {
	  return logs.map(function (log) {
	    return stringify(log);
	  }).join('\n');
	}
	/**
	 * 根据键值获取cookie
	 */

	function getCookie(k) {
	  if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document !== null && document.cookie) {
	    var m = document.cookie.match(new RegExp("(^| )".concat(k, "=([^;]*)(;|$)")));
	    return !m ? '' : decodeURIComponent(m[2]);
	  }

	  return '';
	}
	/**
	 * 获取体系的uin
	 */

	function getUin() {
	  if (['2', '1001', '1002'].indexOf(getCookie('uid_type')) !== -1) {
	    // 微信、游客用户
	    return getCookie('uid_uin') || null;
	  } // QQ用户


	  var u = getCookie('p_luin') || getCookie('p_uin') || getCookie('uin') || getCookie('uid_uin');
	  u = !u ? null : parseInt(u.replace(/[^\d]/g, ''), 10); // 需要转码得到uin

	  u = u || parseInt(getCookie('uin_cookie'), 10) || null; // uin_cookie不需要转码

	  return u;
	}

	/* global JSZip */

	var CDN_PREFIX = 'https://g.gtimg.cn/imweb/imlog/sdkv1';
	var JS_ZIP_SDK = "".concat(CDN_PREFIX, "/jszip.min.js");
	var ACTION_TXT = '日志上传';
	var STYLE = {
	  UPLOAD_MODAL: ['width: 100%;', 'height: 100%;', 'background: rgba(0,0,0,.4);', 'position: fixed;', 'z-index: 9988;', 'top: 0;'].join(''),
	  UPLOAD_BOX: ['text-align: center;', 'width: 200px;', 'background: #fff;', 'position: absolute;', 'top: 50%;', 'left: 50%;', 'transform: translate(-50%,-50%);', 'border-radius: 6px;', 'padding: 10px 0;'].join(''),
	  BUTTON: ['font-size: 14px;', 'border-radius: 3px;', 'width: 90px;', 'height: 30px;', 'background: rgb(45, 64, 117);', 'text-align: center;', 'margin: 20px auto;', 'display: block;', 'color: #fff;', 'outline: none;'].join('')
	};

	var tplDialog = function tplDialog() {
	  return "\n    <div style=\"".concat(STYLE.UPLOAD_MODAL, "\">\n      <div class=\"imlog-box\" style=\"").concat(STYLE.UPLOAD_BOX, "\">\n        \u4E0A\u4F20\u65E5\u5FD7\n        <button class=\"imlog-btn-upload\" style=\"").concat(STYLE.BUTTON, "\">\u4E0A\u4F20\u65E5\u5FD7</button>\n        <button class=\"imlog-btn-close\" style=\"").concat(STYLE.BUTTON, "\">\u5173\u95ED</button>\n      </div>\n    </div>\n  ");
	};

	var fillZero = function fillZero(x) {
	  return x < 10 ? "0".concat(x) : "".concat(x);
	};

	var Uploader =
	/*#__PURE__*/
	function () {
	  function Uploader(options) {
	    var _this = this;

	    _classCallCheck(this, Uploader);

	    _defineProperty(this, "openConfirmDialog", function () {
	      if (!_this.$dialog) {
	        _this.$dialog = document.createElement('div');
	        _this.$dialog.innerHTML = tplDialog();

	        _this.bindEvents();

	        document.body.appendChild(_this.$dialog);

	        _this.log("\u547C\u8D77".concat(ACTION_TXT, "\u5F39\u7A97"));
	      }
	    });

	    this.options = Object.assign({}, Uploader.defaultOpts, options);
	    this.$dialog = null;
	    this.logText = '';
	  }

	  _createClass(Uploader, [{
	    key: "confirm",
	    value: function confirm(logText) {
	      if (!logText) {
	        return;
	      }

	      this.logText = logText;
	    }
	  }, {
	    key: "bindEvents",
	    value: function bindEvents() {
	      var _this2 = this;

	      this.$dialog.addEventListener('click', function (e) {
	        if (e.target.className.indexOf('imlog-btn-upload') >= 0) {
	          _this2.uploadByUser();
	        } else if (e.target.className.indexOf('imlog-btn-close') >= 0) {
	          _this2.close();
	        }
	      });
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      document.body.removeChild(this.$dialog);
	      this.$dialog = null;
	      this.log("\u5173\u95ED".concat(ACTION_TXT, "\u5F39\u7A97"));
	    }
	  }, {
	    key: "zip",
	    value: function zip(fileName) {
	      var zip = new JSZip(); // logs-30273.sz.gfp.tencent-cloud.com/

	      this.log("\b\u538B\u7F29\u65E5\u5FD7\u6587\u4EF6(".concat(fileName, ".zip)"));
	      zip.file("".concat(fileName, ".log"), this.logText);
	      return zip.generateAsync({
	        type: 'blob',
	        compression: 'DEFLATE',
	        compressionOptions: {
	          level: 6
	        }
	      })["catch"](function () {
	        return Promise.reject(new Error('日志内容压缩失败'));
	      });
	    } // sha1(zipFile) {
	    //   try {
	    //     const zipSha1 = sha1.create();
	    //     zipSha1.update(zipFile);
	    //     return zipSha1.hex();
	    //   } catch (e) {
	    //     this.err('日志内容sha1计算失败');
	    //   }
	    // }

	  }, {
	    key: "uploadByUser",
	    value: function uploadByUser() {
	      var _this3 = this;

	      this.uploadBase({
	        beforeUpload: function beforeUpload() {
	          _this3.tip('上传中...');
	        },
	        fileNameNoExist: function fileNameNoExist() {
	          _this3.exit('未设置文件名函数');
	        },
	        success: function success() {
	          _this3.exit("".concat(ACTION_TXT, "\u6210\u529F"));
	        },
	        error: function error(errMsg) {
	          _this3.exit(errMsg);
	        }
	      });
	    }
	  }, {
	    key: "uploadImmediatly",
	    value: function () {
	      var _uploadImmediatly = _asyncToGenerator(
	      /*#__PURE__*/
	      _regeneratorRuntime.mark(function _callee() {
	        var logger;
	        return _regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                logger = this.options.logger;

	                if (!(logger && typeof logger.readLogText === 'function')) {
	                  _context.next = 4;
	                  break;
	                }

	                _context.next = 4;
	                return logger.readLogText();

	              case 4:
	                this.uploadBase({
	                  beforeUpload: function beforeUpload() {
	                    console.log("".concat(ACTION_TXT, "\u4E2D"));
	                  },
	                  fileNameNoExist: function fileNameNoExist() {
	                    console.error("".concat(ACTION_TXT, "\u672A\u8BBE\u7F6E\u6587\u4EF6\u540D\u51FD\u6570"));
	                  },
	                  success: function success() {
	                    console.log("".concat(ACTION_TXT, "\u6210\u529F"));
	                  },
	                  error: function error(errMsg) {
	                    console.error("".concat(ACTION_TXT, "\u5931\u8D25\uFF1A").concat(errMsg));
	                  }
	                });

	              case 5:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));

	      function uploadImmediatly() {
	        return _uploadImmediatly.apply(this, arguments);
	      }

	      return uploadImmediatly;
	    }() // 使用内部cos服务
	    // http://pub.code.oa.com/project/home?projectName=innercos

	  }, {
	    key: "uploadBase",
	    value: function uploadBase(_ref) {
	      var _this4 = this;

	      var beforeUpload = _ref.beforeUpload,
	          fileNameNoExist = _ref.fileNameNoExist,
	          success = _ref.success,
	          error = _ref.error;
	      var _this$options = this.options,
	          appid = _this$options.appid,
	          bucketid = _this$options.bucketid,
	          uploadCGI = _this$options.uploadCGI,
	          setFileName = _this$options.setFileName;

	      if (!setFileName) {
	        if (typeof fileNameNoExist === 'function') {
	          fileNameNoExist();
	        }

	        return;
	      } // cos服务获取Bucket内Object列表时，是按字典序排序的
	      // 需把时间戳放在前面
	      // 带prefix，支持使用日期筛选


	      var now = new Date();
	      var year = now.getFullYear();
	      var month = now.getMonth() + 1;
	      var day = now.getDate();
	      var fileName = "".concat(year, "/").concat(fillZero(month), "/").concat(fillZero(day), "/").concat(now.getTime(), "_").concat(setFileName());

	      if (typeof beforeUpload === 'function') {
	        beforeUpload();
	      }

	      return Uploader.loadSDK().then(function () {
	        _this4.log('加载依赖SDK成功');

	        return _this4.zip(fileName);
	      }).then(function (zipFile) {
	        return fetch("".concat(uploadCGI, "?appid=").concat(appid, "&bucketid=").concat(bucketid, "&name=").concat(fileName, ".zip"), {
	          method: 'POST',
	          body: zipFile // headers: {
	          //   'Content-Type': 'text/plain',
	          // },

	        }).then(function (res) {
	          if (res.ok) {
	            return res.json().then(function (json) {
	              if (json.ec === 0) {
	                if (typeof success === 'function') {
	                  success();
	                }

	                return;
	              }

	              throw new Error("".concat(ACTION_TXT, "\u5931\u8D25").concat(json.ec));
	            });
	          }

	          throw new Error("".concat(ACTION_TXT, "\u5931\u8D25").concat(res.status));
	        });
	      })["catch"](function (e) {
	        _this4.log(e);

	        if (typeof error === 'function') {
	          return error(e.message);
	        }
	      });
	    }
	  }, {
	    key: "tip",
	    value: function tip(_tip) {
	      var $box = this.$dialog.querySelector('.imlog-box');
	      $box.innerText = _tip;
	    }
	  }, {
	    key: "exit",
	    value: function exit(tip) {
	      var _this5 = this;

	      this.tip(tip);
	      setTimeout(function () {
	        _this5.close();
	      }, 2000);
	    }
	  }, {
	    key: "log",
	    value: function log() {
	      var logger = this.options.logger;

	      if (logger && typeof logger.debug === 'function') {
	        logger.debug.apply(logger, arguments);
	      }
	    }
	  }]);

	  return Uploader;
	}();

	_defineProperty(Uploader, "defaultOpts", {
	  logger: null,
	  appid: '30273',
	  bucketid: 'logs',
	  uploadCGI: '//imweblog.qq.com/cgi-bin/cosupload',
	  // 必传参数，设置文件名建议<uin>-<project>-<timestamp>
	  setFileName: null
	});

	_defineProperty(Uploader, "loadSDK", function () {
	  if (!Uploader.loading) {
	    Uploader.loading = new Promise(function (resolve, reject) {
	      if (typeof window.JSZip === 'function') {
	        return resolve();
	      }

	      loadScript([JS_ZIP_SDK], function (e) {
	        if (e && e.type === 'error') {
	          Uploader.loading = null;
	          reject(new Error('依赖加载失败'));
	          return;
	        }

	        resolve(e);
	      });
	    });
	  }

	  return Uploader.loading;
	});

	/**
	 * 日志打印接口函数
	 * @typedef {function(options): undefined|Promise} LogFn
	 * @param {object} options 日志对象
	 * @param {string} [options.msg] 日志内容
	 * @param {Error} options.err 日志数据
	 */

	/**
	 * 日志打印接口函数
	 * @typedef {function(msg, data): undefined|Promise} LogFn
	 * @param {string|Error} msg 日志内容
	 * @param {object} data 日志数据
	 */

	/**
	 * 日志打印接口列表
	 * @example
	 * const imlog = require('imlog');
	 * imlog.trace('foo');
	 * imlog.debug('bar');
	 * imlog.info('foo', { bar: 1 });
	 * imlog.warn(new Error('foo'), { bar: 1 });
	 * imlog.error(new Error('foo'));
	 * imlog.fatal({
	 *   err: new Error('foo'),
	 *   msg: 'bar'
	 * });
	 * @typedef {object} LogInterfaces
	 * @property {LogFn} trace
	 * @property {LogFn} debug
	 * @property {LogFn} info
	 * @property {LogFn} warn
	 * @property {LogFn} error
	 * @property {LogFn} fatal
	 */

	/**
	 * Logger类 - 实现前端日志功能
	 * @mixes {LogInterfaces}
	 */

	var Logger =
	/*#__PURE__*/
	function () {
	  /**
	   * 创建 Logger 实例
	   * @param {string} channel 频道
	   * @param {object} strategies 策略配置
	   * @param {Model} strategies.model
	   * @param {Pool} strategies.pool
	   * @param {Network} strategies.network
	   */
	  function Logger(channel, strategies) {
	    var _this = this;

	    _classCallCheck(this, Logger);

	    _defineProperty(this, "readLogText", function () {
	      // 上传日志不区分channel
	      return _this.read(undefined, Date.now(), null).then(function (logs) {
	        _this.uploader.confirm(transLogText(logs));
	      })["catch"](function (err) {
	        _this.handleError(err);
	      });
	    });

	    this.channel = channel;
	    this.strategies = strategies;
	    this.config(); // 清理过期日志

	    this.keep(); // 监听日志

	    if (channel === 'imlog') {
	      this.bindEvent();
	    }
	  }

	  _createClass(Logger, [{
	    key: "bindEvent",
	    value: function bindEvent() {
	      var _this2 = this;

	      var SHORTCUT_CODE = 88; // 字母X

	      var handler = function handler() {
	        _this2.readLogText().then(function () {
	          _this2.openConfirmDialog();
	        });
	      };

	      document.addEventListener('keydown', function (e) {
	        if (e.keyCode === SHORTCUT_CODE && e.altKey) {
	          handler();
	        }
	      });
	      document.addEventListener('touchend', function (e) {
	        // >=4指点按
	        if (e.touches.length >= 3) {
	          handler();
	        }
	      });
	    }
	  }, {
	    key: "handleError",
	    value: function handleError(err) {
	      if (err && err.message && typeof this.write === 'function') {
	        this.write('error', makeMessage('error', this.channel, "logger\u6A21\u5757\u9519\u8BEF: ".concat(err.message)), {
	          addition: err.stack
	        }, {
	          upload: true,
	          keep: false
	        });
	      }
	    }
	    /**
	     * 配置Logger实例
	     * @example
	     * imlog.configLogger({
	     *   keep: 7,
	     *   autoUpload: imlog.LEVELS.warn
	     * });
	     * @example
	     * const logger = imlog.createLogger('h5pay');
	     * logger.config({
	     *   keep: 7,
	     *   autoUpload: imlog.LEVELS.info,
	     * });
	     * @param {object} options logger相关配置
	     * @param {number} [options.keep=0] 日志本地储存天数
	     * @param {number} [options.autoUpload=imlog.LEVELS.error] 日志自动上传最低级别
	     * {@link @tencent/imlog~LEVELS}
	     * @param {function} [options.setFileName=() => cookie.realUin()] 日志上传时文件命名
	     */

	  }, {
	    key: "config",
	    value: function config() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      this.options = Object.assign(this.options || {}, Logger.defaultOptions, options);
	      this.uploader = new Uploader(_objectSpread({}, this.options, {
	        logger: this
	      }));
	    }
	    /**
	     * 配置日志本地储存天数
	     * @param {number} days 天数
	     */

	  }, {
	    key: "keep",
	    value: function keep(days) {
	      var _this3 = this;

	      if (typeof days === 'number') {
	        this.options.keep = days;
	      } else {
	        days = this.options.keep;
	      }

	      if (typeof this.clear === 'function') {
	        this.clear(0, Date.now() - days * SECONDS_OF_DAY * 1000)["catch"](function (err) {
	          _this3.handleError(err);
	        });
	      }
	    }
	  }, {
	    key: "shouldKeep",
	    value: function shouldKeep() {
	      var keep = this.options.keep;
	      return keep > 0;
	    }
	    /**
	     * 配置日志自动上传最低级别
	     * @param {LEVELS} level 级别
	     */

	  }, {
	    key: "autoUpload",
	    value: function autoUpload(level) {
	      var val = Object.values(LEVELS).indexOf(level) > -1 ? level : LEVELS[level];

	      if (val) {
	        this.options.autoUpload = val;
	      }
	    }
	  }, {
	    key: "shouldAutoUpload",
	    value: function shouldAutoUpload(level) {
	      var autoUpload = this.options.autoUpload;
	      return LEVELS[level] >= autoUpload;
	    }
	    /**
	     * 配置网络请求日志抓取
	     * @param {object} options 抓取开关对象
	     */

	  }, {
	    key: "autoCollect",
	    value: function autoCollect() {}
	  }, {
	    key: "filterRow",
	    value: function filterRow(row) {
	      var excludeKeys = this.options.excludeKeys;

	      var data = _objectSpread({}, row);

	      excludeKeys.forEach(function (k) {
	        delete data[k];
	      });
	      return data;
	    }
	    /**
	     * 预设一次上报额外字段
	     * @param {object} options 补充字段对象
	     * @returns Logger
	     * @example
	     * imlog.extra({ addition: xxx }).info('支付成功')
	     */

	  }, {
	    key: "extra",
	    value: function extra(options) {
	      var _this4 = this;

	      var logger = Object.create(this);
	      Object.keys(LEVELS).forEach(function (level) {
	        logger[level] = function () {
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }

	          _this4[level].apply(_this4, _toConsumableArray(args.concat(options)));
	        };
	      });
	      return logger;
	    }
	    /**
	     * 预设一次日志前缀
	     * @param {prefix} string 前缀
	     * @returns Logger
	     * @example
	     * imlog.prefix('discount模块').error('拉取优惠信息失败')
	     */

	  }, {
	    key: "prefix",
	    value: function prefix(_prefix) {
	      var _this5 = this;

	      var logger = Object.create(this);
	      Object.keys(LEVELS).forEach(function (level) {
	        logger[level] = _this5[level].bind(logger, _prefix);
	      });
	      return logger;
	    }
	  }, {
	    key: "upload",
	    value: function upload() {
	      this.uploader.uploadImmediatly();
	    }
	  }, {
	    key: "write",
	    value: function write(level, message) {
	      var _opts$upload;

	      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      var channel = this.channel;
	      var _this$strategies = this.strategies,
	          model = _this$strategies.model,
	          pool = _this$strategies.pool;
	      var data = opts.data || model.generateRow(_objectSpread({}, extra, {
	        type: level,
	        channel: channel,
	        message: message
	      }));

	      if ((_opts$upload = opts.upload) !== null && _opts$upload !== void 0 ? _opts$upload : this.shouldAutoUpload(level)) {
	        pool.add(data);
	      }
	    }
	  }]);

	  return Logger;
	}();

	_defineProperty(Logger, "support", true);

	_defineProperty(Logger, "defaultOptions", {
	  // 日志保留天数
	  keep: 0,
	  // 日志字段剔除
	  excludeKeys: ['source', 'user_agent'],
	  // 自动上传的日志最小级别
	  autoUpload: LEVELS.error,
	  // 上传日志文件名获取
	  setFileName: function setFileName() {
	    return getUin() || 'unknown';
	  }
	});

	Object.keys(LEVELS).forEach(function (level) {
	  Logger.prototype[level] = function () {
	    if (typeof this.write === 'function') {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }

	      var _makeRecord = makeRecord(level, this.channel, args),
	          message = _makeRecord.message,
	          extra = _makeRecord.extra,
	          filteredArgs = _makeRecord.filteredArgs;

	      var tailArg = args[args.length - 1]; // 兼容老逻辑

	      Object.assign(extra, makeExtra(tailArg));
	      writeConsole(this.channel, level, message, filteredArgs);
	      this.write(level, message, _objectSpread({}, extra, {
	        url: window.location.href
	      }));
	    }

	    return this;
	  };
	});

	var IndexedDBLogger =
	/*#__PURE__*/
	function (_Logger) {
	  _inherits(IndexedDBLogger, _Logger);

	  function IndexedDBLogger(channel, strategies) {
	    var _this;

	    _classCallCheck(this, IndexedDBLogger);

	    _this = _possibleConstructorReturn(this, _getPrototypeOf(IndexedDBLogger).call(this, channel, strategies)); // 连接IndexedDB

	    IndexedDBLogger.connect();
	    return _this;
	  }
	  /**
	   * @ignore
	   * 连接IndexedDB拿到db实例
	   */


	  _createClass(IndexedDBLogger, [{
	    key: "clear",
	    value: function clear(from, to, channel) {
	      // 清除日志必须区分channel
	      channel = channel || this.channel;
	      return IndexedDBLogger.clear(from, to, channel);
	    }
	  }, {
	    key: "read",
	    value: function read(from, to) {
	      var channel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.channel;
	      return IndexedDBLogger.read(from, to, channel);
	    }
	    /**
	     * 将日志写入IndexedDB并上报
	     * @ignore
	     * @param {string} level 日志等级
	     * @param {string} message 日志内容
	     * @param {object} extra 附加字段
	     * @param {object} opts 自定义配置
	     */

	  }, {
	    key: "write",
	    value: function write(level, message) {
	      var _opts$keep,
	          _this2 = this;

	      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      var channel = this.channel;
	      var model = this.strategies.model;
	      var data = model.generateRow(_objectSpread({}, extra, {
	        type: level,
	        channel: channel,
	        message: message
	      }));

	      _get(_getPrototypeOf(IndexedDBLogger.prototype), "write", this).call(this, level, message, extra, _objectSpread({}, opts, {
	        data: data // 避免父方法重新generate

	      }));

	      if ((_opts$keep = opts.keep) !== null && _opts$keep !== void 0 ? _opts$keep : this.shouldKeep()) {
	        IndexedDBLogger.connectStore().then(function (store) {
	          var request = store.add(_this2.filterRow(data));

	          request.onerror = function (err) {
	            _this2.handleError(err);
	          };
	        });
	      }
	    }
	  }], [{
	    key: "connect",
	    value: function connect() {
	      var database = IndexedDBLogger.database,
	          connected = IndexedDBLogger.connected;

	      if (database) {
	        return Promise.resolve(database);
	      }

	      if (!connected) {
	        IndexedDBLogger.connected = new Promise(function (resolve, reject) {
	          try {
	            var request = window.indexedDB.open(IMLOG_DB_NAME, IMLOG_DB_VERSION);
	            request.onerror = reject;

	            request.onupgradeneeded = function (e) {
	              var db = e.target.result;
	              Object.entries(IMLOG_DB_STORES).forEach(function (_ref) {
	                var _ref2 = _slicedToArray(_ref, 2),
	                    k = _ref2[0],
	                    v = _ref2[1];

	                var options = v.options,
	                    indexes = v.indexes;
	                var objectStore = db.createObjectStore(k, options);
	                Object.entries(indexes).forEach(function (_ref3) {
	                  var _ref4 = _slicedToArray(_ref3, 2),
	                      i = _ref4[0],
	                      j = _ref4[1];

	                  objectStore.createIndex.apply(objectStore, [i].concat(_toConsumableArray(j)));
	                });
	              });
	            };

	            request.onsuccess = function (e) {
	              IndexedDBLogger.database = e.target.result;
	              resolve(e.target.result);
	            };
	          } catch (err) {
	            reject(err);
	          }
	        });
	      }

	      return IndexedDBLogger.connected;
	    }
	    /**
	     * @ignore
	     * 获取db中的logs Store实例
	     */

	  }, {
	    key: "connectStore",
	    value: function connectStore() {
	      return this.connect().then(function (db) {
	        var transaction = db.transaction([IMLOG_DB_STORE_NAME], 'readwrite');
	        return transaction.objectStore(IMLOG_DB_STORE_NAME);
	      });
	    }
	    /**
	     * 清除某段时间的日志
	     * @ignore
	     * @param {number} from 起始时间
	     * @param {number} to 结束时间
	     */

	  }, {
	    key: "clear",
	    value: function clear() {
	      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var to = arguments.length > 1 ? arguments[1] : undefined;
	      var channel = arguments.length > 2 ? arguments[2] : undefined;

	      if (typeof to === 'undefined' || Number.isNaN(+to) || +to <= from) {
	        // 无截止范围拒绝清除
	        return Promise.reject(new Error('截止范围时间戳无效'));
	      }

	      return IndexedDBLogger.connectStore().then(function (store) {
	        return new Promise(function (resolve, reject) {
	          var indexStore = store.index(IMLOG_DB_INDEX_TS);
	          to = +to;
	          var range = window.IDBKeyRange.bound(from, to);
	          var request = indexStore.openCursor(range);
	          request.onerror = reject;

	          request.onsuccess = function (e) {
	            var cursor = e.target.result;

	            if (cursor) {
	              var item = cursor.value;

	              if (!channel || item.channel === channel) {
	                store["delete"](cursor.primaryKey);
	              }

	              cursor["continue"]();
	            } else {
	              resolve();
	            }
	          };
	        });
	      });
	    }
	  }, {
	    key: "read",
	    value: function read() {
	      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
	      var channel = arguments.length > 2 ? arguments[2] : undefined;
	      return IndexedDBLogger.connectStore().then(function (store) {
	        var indexStore = store.index(IMLOG_DB_INDEX_TS);
	        var result = [];
	        return new Promise(function (resolve, reject) {
	          to = +to;

	          if (!Number.isNaN(to) && to > from) {
	            var range = window.IDBKeyRange.bound(from, to);
	            var request = indexStore.openCursor(range);
	            request.onerror = reject;

	            request.onsuccess = function (e) {
	              var cursor = e.target.result;

	              if (cursor) {
	                var item = cursor.value;

	                if (!channel || item.channel === channel) {
	                  result.push(item);
	                }

	                cursor["continue"]();
	              } else {
	                resolve(result);
	              }
	            };

	            return;
	          }

	          return reject(new Error('read调用参数错误'));
	        });
	      });
	    }
	  }]);

	  return IndexedDBLogger;
	}(Logger);

	_defineProperty(IndexedDBLogger, "support", isIndexedDBSupport);

	var SupportedLogger = null;
	[IndexedDBLogger].some(function (x) {
	  return x.support && (SupportedLogger = x);
	});
	var BrowserLogger = SupportedLogger || Logger;

	if (!SupportedLogger) {
	  console.warn('[IMLOG]日志模块本地储存不可用');
	}

	BrowserLogger.LEVEL = LEVELS;
	BrowserLogger.LEVELS = LEVELS;

	/**
	 * Polyfill a method, Copied from raven-js
	 * @ignore
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  if (obj == null) {
	    return;
	  }

	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  obj[name].__imlog__ = true;
	  obj[name].__imlog_fill__ = orig;

	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	function supportsFetch() {
	  if (!('fetch' in window)) {
	    return false;
	  }

	  try {
	    new Headers(); // eslint-disable-line no-new

	    new Request(''); // eslint-disable-line no-new

	    new Response(); // eslint-disable-line no-new

	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	var isSupportFetch = supportsFetch();

	function match(s, pattern) {
	  if (!pattern) {
	    return false;
	  }

	  if (typeof pattern === 'string') {
	    return s.indexOf(pattern) >= 0;
	  }

	  if (pattern instanceof RegExp) {
	    return pattern.test(s);
	  }

	  return false;
	}

	function multiInclude(s, patterns) {
	  if (!Array.isArray(patterns)) {
	    patterns = [patterns];
	  }

	  return patterns.some(function (pattern) {
	    return match(s, pattern);
	  });
	}

	function multiExclude(s, patterns) {
	  if (!Array.isArray(patterns)) {
	    patterns = [patterns];
	  }

	  return patterns.every(function (pattern) {
	    return !match(s, pattern);
	  });
	}
	/**
	 * 根据配置判断是否匹配
	 * @param {string} s 匹配对象
	 * @param {array} options.include (string|regex)[]配置
	 * @param {array} options.exclude (string|regex)[]配置
	 */


	function multiMatch(s, options) {
	  var includes = options.includes,
	      excludes = options.excludes;

	  if (includes && !multiInclude(s, includes)) {
	    return false;
	  }

	  if (excludes && !multiExclude(s, excludes)) {
	    return false;
	  }

	  return true;
	}

	var multimatch = {
	  multiMatch: multiMatch,
	  multiInclude: multiInclude,
	  multiExclude: multiExclude
	};
	var multimatch_1 = multimatch.multiMatch;

	/**
	 * Network类 - 用于监听 xhr, fetch, ws 网络请求数据并提供事件订阅
	 * @memberof @tencent/imlog/src/lib
	 */

	var Network =
	/*#__PURE__*/
	function (_EventEmitter) {
	  _inherits(Network, _EventEmitter);

	  // 正在监听的网络实例
	  // 内置API包裹记录
	  function Network(options) {
	    var _this;

	    _classCallCheck(this, Network);

	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Network).call(this));

	    _this.config(options);

	    return _this;
	  }
	  /**
	   * 配置抓取规则，提供响应Content-Type和Url两种过滤方式
	   * @param {Object} options 配置
	   * @param {string|string[]} options.ignoreUrls @deprecated 忽略的urls
	   * @param {string|string[]} options.resContenTypeWhiteList @deprecated 包含的响应type
	   * @param {string|string[]} options.resContenTypeBlackList @deprecated 忽略的响应type
	   * @param {Object} options.urlPatterns url过滤配置
	   * @param {(string|RegExp|Array.<string|RegExp>)} options.urlPatterns.includes
	   * @param {(string|RegExp|Array.<string|RegExp>)} options.urlPatterns.excludes
	   * @param {Object} options.resContentTypePatterns 响应type过滤配置
	   * @param {(string|RegExp|Array.<string|RegExp>)} [options.resContentTypePatterns.includes=['application/json']]
	   * @param {(string|RegExp|Array.<string|RegExp>)} [options.resContentTypePatterns.excludes=['video']]
	   */


	  _createClass(Network, [{
	    key: "config",
	    value: function config() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var ignoreUrls = options.ignoreUrls,
	          resContenTypeWhiteList = options.resContenTypeWhiteList,
	          resContenTypeBlackList = options.resContenTypeBlackList,
	          rest = _objectWithoutProperties(options, ["ignoreUrls", "resContenTypeWhiteList", "resContenTypeBlackList"]);

	      if (ignoreUrls) {
	        rest.urlPatterns = {
	          excludes: ignoreUrls
	        };
	      }

	      if (resContenTypeWhiteList || resContenTypeBlackList) {
	        rest.resContentTypePatterns = {
	          includes: resContenTypeWhiteList,
	          excludes: resContenTypeBlackList
	        };
	      }

	      this.options = Object.assign({}, Network.defaultOpts, rest);
	    }
	  }, {
	    key: "isUrlMatched",
	    value: function isUrlMatched(url) {
	      var urlPatterns = this.options.urlPatterns;
	      return multimatch_1(url, urlPatterns);
	    }
	  }, {
	    key: "isResContentTypeMatched",
	    value: function isResContentTypeMatched(type) {
	      var resContentType = this.options.resContentType;
	      return multimatch_1(type, resContentType);
	    }
	  }, {
	    key: "on",

	    /**
	     * 监听网络请求事件
	     * @param {string} eventName 事件名(xhr|fetch|ws)
	     * @param {callback} listener 监听器
	     */
	    value: function on(eventName, listener) {
	      var method = "".concat(eventName, "Init");

	      if (typeof Network[method] === 'function') {
	        Network[method](this);
	      }

	      _get(_getPrototypeOf(Network.prototype), "on", this).call(this, eventName, listener);

	      return this;
	    }
	  }, {
	    key: "emit",
	    value: function emit(eventName) {
	      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }

	      var imlogData = args[0];
	      var url = imlogData.url,
	          contentType = imlogData.contentType;

	      if (this.isUrlMatched(url) && (!contentType || !this.isResContentTypeMatched(contentType)) && !/imweblog|localhost|whistle|sentry/.test(url)) {
	        var _get2;

	        (_get2 = _get(_getPrototypeOf(Network.prototype), "emit", this)).call.apply(_get2, [this, eventName].concat(args));
	      }

	      return this;
	    }
	  }], [{
	    key: "wrap",
	    value: function wrap(func, before) {
	      if (typeof func !== 'function') {
	        return func;
	      } // We don't wanna wrap it twice!


	      try {
	        if (func.__imlog__) {
	          return func;
	        } // If this has already been wrapped in the past, return that


	        if (func.__imlog_wrapper__) {
	          return func.__imlog_wrapper__;
	        }
	      } catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see raven-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return func;
	      }

	      function wrapped() {
	        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          args[_key2] = arguments[_key2];
	        }

	        try {
	          if (before && utils_3(before)) {
	            before.apply(this, args);
	          }
	        } catch (e) {}

	        return func.apply(this, args);
	      } // copy over properties of the old function


	      Object.keys(func).forEach(function (property) {
	        wrapped[property] = func[property];
	      });
	      wrapped.prototype = func.prototype;
	      func.__imlog_wrapper__ = wrapped; // Signal that this function has been wrapped already
	      // for both debugging and to prevent it to being wrapped twice

	      wrapped.__imlog__ = true;
	      wrapped.__imlog_inner__ = func;
	      return wrapped;
	    }
	  }, {
	    key: "trigger",
	    value: function trigger(eventName) {
	      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        args[_key3 - 1] = arguments[_key3];
	      }

	      Network.networks.forEach(function (network) {
	        network.emit.apply(network, [eventName].concat(args));
	      });
	    }
	  }, {
	    key: "addListener",
	    value: function addListener(network) {
	      var networks = Network.networks;

	      if (!networks.includes(network)) {
	        networks.push(network);
	      }
	    }
	  }, {
	    key: "xhrInit",
	    value: function xhrInit(self) {
	      var wrappedBuiltIns = Network.wrappedBuiltIns;
	      Network.addListener(self);

	      if (Network.isXhrInited) {
	        return;
	      }

	      Network.isXhrInited = true;

	      if ('XMLHttpRequest' in consts_7) {
	        var xhrproto = XMLHttpRequest.prototype;
	        fill(xhrproto, 'open', function (origOpen) {
	          return function () {
	            for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	              args[_key4] = arguments[_key4];
	            }

	            var method = args[0];
	            var url = args[1];
	            this.__imlog_xhr = {
	              url: url,
	              method: method,
	              reqHeaders: {},
	              reqBody: null,
	              status: null,
	              response: null,
	              resContentType: null,
	              cost: null,
	              start: Date.now()
	            };
	            return origOpen.apply(this, args);
	          };
	        }, wrappedBuiltIns);
	        fill(xhrproto, 'setRequestHeader', function (origSetRequestHeader) {
	          return function () {
	            for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	              args[_key5] = arguments[_key5];
	            }

	            var header = args[0];
	            var value = args[1];

	            if (utils_1(header) && this.__imlog_xhr) {
	              this.__imlog_xhr.reqHeaders[header] = value;
	            }

	            return origSetRequestHeader.apply(this, args);
	          };
	        }, wrappedBuiltIns);
	        fill(xhrproto, 'send', function (origSend) {
	          return function () {
	            for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	              args[_key6] = arguments[_key6];
	            }

	            var xhr = this;

	            function onreadystatechangeHandler() {
	              if (xhr.__imlog_xhr && xhr.readyState === 4) {
	                var imlogXhr = xhr.__imlog_xhr;

	                try {
	                  var start = imlogXhr.start;
	                  imlogXhr.reqBody = args[0];
	                  imlogXhr.status = xhr.status;
	                  imlogXhr.response = xhr.response;
	                  imlogXhr.cost = Date.now() - start;
	                  imlogXhr.resContentType = xhr.getResponseHeader('Content-Type');
	                } catch (e) {}

	                Network.trigger('xhr', imlogXhr);
	              }
	            }

	            if ('onreadystatechange' in xhr && utils_3(xhr.onreadystatechange)) {
	              fill(xhr, 'onreadystatechange', function (orig) {
	                return Network.wrap(orig, onreadystatechangeHandler);
	              }
	              /* intentionally don't track this instrumentation */
	              );
	            } else {
	              // if onreadystatechange wasn't actually set by the page on this xhr, we
	              // are free to set our own and capture the breadcrumb
	              xhr.onreadystatechange = onreadystatechangeHandler;
	            }

	            return origSend.apply(this, args);
	          };
	        }, wrappedBuiltIns);
	      }
	    }
	  }, {
	    key: "fetchInit",
	    value: function fetchInit(self) {
	      if (!isSupportFetch) {
	        return;
	      }

	      var wrappedBuiltIns = Network.wrappedBuiltIns;
	      Network.addListener(self);

	      if (Network.isFetchInited) {
	        return;
	      }

	      Network.isFetchInited = true;

	      if ('fetch' in consts_7) {
	        fill(consts_7, 'fetch', function (origFetch) {
	          return function () {
	            var options = {};

	            for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	              args[_key7] = arguments[_key7];
	            }

	            var url = args[0];
	            var method = 'GET';
	            var reqHeaders = {};
	            var reqBody = null;

	            if ('Request' in consts_7 && args[0] instanceof consts_7.Request) {
	              options = args[0];
	            } else {
	              options = args[1] || options;
	            } // 如果第一个参数为string，优先取第一个参数
	            // @fix options.url无query但args[0]有query的情况


	            url = typeof url === 'string' ? url : options.url;
	            method = options.method || method;
	            reqHeaders = options.headers || reqHeaders;
	            reqBody = options.body || reqBody;
	            var imlogFetch = {
	              url: url,
	              method: method,
	              reqHeaders: reqHeaders,
	              reqBody: reqBody,
	              start: Date.now()
	            };
	            return origFetch.apply(this, args).then(function (response) {
	              try {
	                imlogFetch.status = response.status;
	                imlogFetch.cost = Date.now() - imlogFetch.start;
	                imlogFetch.resContentType = response.headers.get('Content-Type'); // safari不支持clone API

	                var cloned = response.clone();
	                cloned.text().then(function (text) {
	                  imlogFetch.response = text;
	                  Network.trigger('fetch', imlogFetch);
	                });
	              } catch (e) {
	                Network.trigger('fetch', imlogFetch);
	              }

	              return response;
	            });
	          };
	        }, wrappedBuiltIns);
	      }
	    }
	  }, {
	    key: "wsInit",
	    value: function wsInit(self) {
	      if (!('defineProperty' in Object)) {
	        return;
	      }

	      Network.addListener(self);

	      if (Network.isWsInited) {
	        return;
	      }

	      Network.isWsInited = true; // const ws = new AnyWS();
	      // const trans = Network.transWsInfo;
	      // WEBSOCKET_HANDLER_KEY.forEach(eventKey => {
	      //   ws.add(eventKey, function(data) {
	      //     Network.trigger('ws', trans(this, data, eventKey));
	      //   });
	      // });
	    } // 格式转化ws信息

	  }, {
	    key: "transWsInfo",
	    value: function transWsInfo(wsInstance, arg, eventType) {
	      var _wsInstance$url = wsInstance.url,
	          url = _wsInstance$url === void 0 ? '' : _wsInstance$url,
	          _wsInstance$readyStat = wsInstance.readyState,
	          readyState = _wsInstance$readyStat === void 0 ? 0 : _wsInstance$readyStat;
	      var info = {
	        url: url,
	        readyState: readyState
	      };

	      if (arg instanceof Event) {
	        var data = arg.data,
	            code = arg.code,
	            type = arg.type,
	            timeStamp = arg.timeStamp;
	        info.eventType = type;
	        info.timeStamp = timeStamp;

	        if (data) {
	          info.data = data;
	        }

	        if (code) {
	          info.code = code;
	        }
	      } else {
	        info.eventType = eventType;
	        info.data = arg;
	      }

	      return info;
	    }
	  }]);

	  return Network;
	}(EventEmitter);

	_defineProperty(Network, "defaultOpts", {
	  // 是否记录response内容黑白名单
	  resContentTypePatterns: {
	    includes: ['application/json'],
	    excludes: ['video']
	  },
	  // 忽略的urls
	  urlPatterns: {}
	});

	_defineProperty(Network, "networks", []);

	_defineProperty(Network, "wrappedBuiltIns", []);

	var BrowserNetwork = utils_10(Network);

	var BASE_POINT_KEY = 'navigationStart';
	var CUSTOM_POINT_KEYS = ['page_css_ready', 'page_js_ready', 'page_main_start', 'page_main_end', 'page_render_end', 'page_render_fp'];
	var PERFORMANCE_POINT_KEYS = {
	  unload_event_start: 1,
	  unload_event_end: 2,
	  redirect_start: 3,
	  redirect_end: 4,
	  fetch_start: 5,
	  domain_lookup_start: 6,
	  domain_lookup_end: 7,
	  connect_start: 8,
	  connect_end: 9,
	  request_start: 10,
	  response_start: 11,
	  response_end: 12,
	  dom_loading: 13,
	  dom_interactive: 14,
	  dom_content_loaded_event_start: 15,
	  dom_content_loaded_event_end: 16,
	  dom_complete: 17,
	  load_event_start: 18,
	  load_event_end: 19
	};

	var POINT_KEYS = _objectSpread({}, PERFORMANCE_POINT_KEYS, CUSTOM_POINT_KEYS.reduce(function (keys, p, i) {
	  keys[p] = i + 20;
	  return keys;
	}, {}));

	function serilizePoints(params) {
	  var q = '';
	  Object.entries(params).forEach(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        k = _ref2[0],
	        v = _ref2[1];

	    var point = POINT_KEYS[k];

	    if (point) {
	      q += "&".concat(point, "=").concat(v);
	    }
	  });
	  return q;
	}

	function parseURL(url) {
	  var a = document.createElement('a');
	  a.href = url;
	  return a;
	}
	/**
	 * Speed类 - 实现页面测速，CGI返回码测速上报
	 */


	var Speed =
	/*#__PURE__*/
	function () {
	  /**
	   * 创建Speed实例
	   * @param {Object} options
	   * @param {Model} options.model
	   * @param {Pool} options.pool
	   */
	  function Speed(_ref3) {
	    var model = _ref3.model,
	        pool = _ref3.pool;

	    _classCallCheck(this, Speed);

	    this.model = model;
	    this.pool = pool;
	    this.reported = false;
	    this.config();
	    this.init();
	  }
	  /**
	   * 配置测速
	   * @example
	   * imlog.configSpeed({
	   *   ecProp: ['retcode'],
	   *   ecDefault: -1000,
	   *   include: /cgi-/,
	   *   exclude: /imweblog|nohost/,
	   * });
	   * @param {Object} options 配置
	   * @param {string|number} options.wangAppid wang系统appid
	   * @param {string} options.wangId wang系统页面id
	   * @param {string} options.platform wang系统平台字段
	   * @param {Object} options.extra wang系统其它公共字段
	   * @param {string[]} [options.ecProps=['retcode', 'ret', 'ec']] 抓取网络请求中响应内容取code的字段列表
	   * @param {number} [options.ecDefault=-1000] 抓取网络请求中响应内容取code失败的默认值
	   * @param {string|RegExp|Array.<string|RegExp>} [options.includes=/cgi-/] 过滤器，包含上报的CGI
	   * @param {string|RegExp|Array.<string|RegExp>} [options.excludes=/(imweblog|nohost)/] 过滤器，排除上报的CGI
	   */


	  _createClass(Speed, [{
	    key: "config",
	    value: function config() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      var wangAppid = options.wangAppid,
	          wangId = options.wangId,
	          platform = options.platform,
	          extra = options.extra,
	          rest = _objectWithoutProperties(options, ["wangAppid", "wangId", "platform", "extra"]);

	      var _this$model$baseData = this.model.baseData,
	          baseData = _this$model$baseData === void 0 ? {} : _this$model$baseData; // wang系统配置

	      this.extra = _objectSpread({
	        wangAppid: wangAppid,
	        wangId: wangId,
	        platform: platform
	      }, extra);

	      if (baseData && baseData.uin) {
	        imWang.config({
	          uin: baseData.uin
	        });
	      }

	      if (!this.network || Object.keys(rest).length) {
	        this.options = _objectSpread({}, Speed.defaultOpts, rest);
	        var _this$options = this.options,
	            includes = _this$options.includes,
	            excludes = _this$options.excludes;
	        var networkOpts = {
	          urlPatterns: {
	            includes: includes,
	            excludes: excludes
	          }
	        };
	        this.network = this.network ? this.network.config(networkOpts) : new Network(networkOpts);
	      }
	    }
	  }, {
	    key: "init",
	    value: function init() {
	      var _this = this;

	      var handler = function handler(data) {
	        var url = data.url,
	            method = data.method,
	            cost = data.cost,
	            response = data.response,
	            status = data.status,
	            reqHeaders = data.reqHeaders,
	            reqBody = data.reqBody;

	        var retcode = _this.retcode(response);

	        var extra = {
	          statusCode: status,
	          message: response
	        };

	        if (reqHeaders && Object.keys(reqHeaders).length) {
	          extra.headers = reqHeaders;
	        }

	        if (reqBody) {
	          extra.body = reqBody;
	        }

	        _this.speed(url, method, cost, retcode, extra);
	      };

	      this.network.on('xhr', handler).on('fetch', handler);
	    }
	    /**
	     * 生成一条测速记录
	     */

	  }, {
	    key: "make",
	    value: function make(url, method, costTime, retcode, extra) {
	      if (typeof url !== 'string' || typeof method !== 'string' || typeof costTime !== 'number' || typeof retcode !== 'number') {
	        return;
	      }

	      var urlOpts = parseURL(url);
	      var wangAppid = this.extra.wangAppid || extra.wangAppid;
	      var protocol = urlOpts.protocol,
	          host = urlOpts.host,
	          pathname = urlOpts.pathname,
	          search = urlOpts.search;
	      return this.model.generateRow(consts_1.speed, _objectSpread({
	        wangAppid: wangAppid,
	        cmd: "".concat(protocol, "//").concat(host).concat(pathname),
	        addition: search,
	        method: method,
	        costTime: costTime,
	        retcode: retcode
	      }, extra));
	    }
	  }, {
	    key: "retcode",
	    value: function retcode(response) {
	      var _this$options2 = this.options,
	          ecProps = _this$options2.ecProps,
	          ecDafault = _this$options2.ecDafault;
	      var json;

	      try {
	        // JSON.parse有可能返回null
	        json = JSON.parse(response) || {};
	      } catch (e) {
	        return ecDafault;
	      }

	      for (var i = 0; i < ecProps.length; i++) {
	        var prop = ecProps[i];

	        if (typeof json[prop] === 'number') {
	          return json[prop];
	        }
	      }

	      return ecDafault;
	    }
	    /**
	     * 上报一条CGI返回码测速数据
	     * @example
	     * imlog.speed('https://ke.qq.com/cgi-bin/userinfo', 'GET', 100, 0, {
	     *   headers: 'xxx',
	     * });
	     * @param {string} url CGI地址(支持只传path)
	     * {@link https://www.npmjs.com/package/url-parse#usage|使用url-parse包解析}
	     * @param {string} method 请求方法
	     * @param {number} costTime 耗时
	     * @param {number} retcode 返回码
	     * @param {Object} extra 其他符合的字段
	     * {@link http://dc.cp.oa.com/index.php/index/config?menu_id=01-02&rowid=8491|DC测速表}
	     */

	  }, {
	    key: "speed",
	    value: function speed(url, method, costTime, retcode, extra) {
	      var row = this.make(url, method, costTime, retcode, extra);
	      this.pool.add(row);

	      if (this.extra.wangAppid) {
	        this.forward(row);
	      }
	    }
	  }, {
	    key: "speedOnlyForward",
	    value: function speedOnlyForward(url, method, costTime, retcode, extra) {
	      var row = this.make(url, method, costTime, retcode, extra); // @fix 兼容父项目未配置imlog，请求库上报兜底的情况

	      if (row && !this.extra.wangAppid && extra.wangAppid) {
	        this.forward(row);
	      }
	    }
	    /**
	     * 记录页面首屏时间
	     * @example
	     * componentDidMount() {
	     *   imlog.pageRenderFp();
	     * }
	     */

	  }, {
	    key: "pageRenderFp",
	    value: function pageRenderFp() {
	      this.page_render_fp = Date.now();
	    }
	    /**
	     * 记录页面渲染完成时间，并上报页面测速
	     * @example
	     * componentDidMount() {
	     *   imlog.pageRenderEnd();
	     * }
	     */

	  }, {
	    key: "pageRenderEnd",
	    value: function pageRenderEnd() {
	      this.page_render_end = Date.now();
	      this.report();
	    }
	  }, {
	    key: "performance",
	    value: function performance() {
	      var _this2 = this;

	      // iOS 8不支持performance API
	      // safari 不支持window.performance.timing.toJSON
	      var basePoint;
	      var points = {};

	      try {
	        basePoint = window.performance.timing[BASE_POINT_KEY];
	        points = Object.keys(PERFORMANCE_POINT_KEYS).reduce(function (o, key) {
	          var camelCaseKey = key.replace(/_([a-z])/g, function (s, m1) {
	            return m1.toUpperCase();
	          });
	          o[camelCaseKey] = window.performance.timing[camelCaseKey];
	          return o;
	        }, {});
	      } catch (e) {}

	      if (!basePoint) {
	        // navigationStart起始点无效的时候不上报
	        return;
	      }

	      Object.keys(points).concat(CUSTOM_POINT_KEYS).forEach(function (k) {
	        var v = typeof points[k] === 'number' ? points[k] : _this2[k];
	        var cost = v - basePoint; // 维持原逻辑为1

	        points[k] = Number.isNaN(cost) || cost < 0 ? 1 : cost;
	      });
	      return points;
	    }
	  }, {
	    key: "report",
	    value: function report() {
	      var points = this.performance();

	      if (!points) {
	        // TODO 监控
	        return;
	      }

	      var row = this.model.generateRow(consts_1.pageSpeed, _objectSpread({}, points, this.extra));
	      var _this$extra = this.extra,
	          wangAppid = _this$extra.wangAppid,
	          wangId = _this$extra.wangId;
	      this.pool.add(row);

	      if (wangAppid && wangId) {
	        this.forward(row);
	      }

	      this.reported = true;
	    }
	  }, {
	    key: "forward",
	    value: function forward(row) {
	      var type = row.type,
	          appid = row.wangAppid;

	      if (type === consts_1.speed) {
	        var cmd = row.cmd,
	            code = row.retcode,
	            time = row.costTime;

	        var _parseURL = parseURL(cmd),
	            domain = _parseURL.host,
	            cgi = _parseURL.pathname;

	        imWang.reportCode({
	          appid: appid,
	          domain: domain,
	          cgi: cgi,
	          code: code,
	          time: time
	        });
	      } else if (type === consts_1.pageSpeed) {
	        var pageid = row.wangId,
	            platform = row.platform;
	        var points = serilizePoints(row);
	        imWang.report({
	          appid: appid,
	          pageid: pageid,
	          platform: platform,
	          speedparams: encodeURIComponent("".concat(pageid).concat(points))
	        });
	      }
	    }
	  }]);

	  return Speed;
	}();

	_defineProperty(Speed, "defaultOpts", {
	  ecProps: ['retcode', 'ret', 'ec'],
	  ecDafault: -1000,
	  includes: /cgi-/,
	  excludes: /(imweblog|nohost)/
	});

	/**
	 * Tdw类 - 实现tdw上报接口
	 */

	var Tdw =
	/*#__PURE__*/
	function () {
	  function Tdw() {
	    _classCallCheck(this, Tdw);
	  }

	  _createClass(Tdw, [{
	    key: "integrate",
	    value: function integrate() {
	      if (this.integrated) {
	        return;
	      }

	      this.integrated = true;
	      this.reportor = reportor;
	    }
	    /**
	     * 全局上报值配置
	     * @example
	     * imlog.configTdw({
	     *   page: 'course',
	     *   platform: 1,
	     * })
	     * @param {Object} options 全局配置
	     * {@link https://docs.google.com/spreadsheets/d/1Q_iBQKX1mycmtoz7Mi4I729TTevCTgvDaFipRs_c2vg/edit#gid=1223109352}
	     */

	  }, {
	    key: "config",
	    value: function config() {
	      this.integrate();

	      if (this.reportor && utils_3(this.reportor.config)) {
	        var _this$reportor;

	        (_this$reportor = this.reportor).config.apply(_this$reportor, arguments);
	      }
	    }
	    /**
	     * 上报一条数据
	     * @example
	     * imlog.tdw({
	     *   module: 'app_bar',
	     *   action: 'exposure',
	     * })
	     * @param {Object} data 行为数据
	     * {@link https://docs.google.com/spreadsheets/d/1vdjTJMa7THVnircSwPC7svuVLbIRlUvT1JZBBVJ6-UU/edit#gid=621911183}
	     */

	  }, {
	    key: "tdw",
	    value: function tdw() {
	      this.integrate();

	      if (this.reportor && utils_3(this.reportor.tdw)) {
	        var _this$reportor2;

	        (_this$reportor2 = this.reportor).tdw.apply(_this$reportor2, arguments);
	      }
	    }
	    /**
	     * 上报pageview
	     * @example
	     * imlog.reportPageView();
	     * @param {Object} data 行为数据
	     * {@link https://docs.google.com/spreadsheets/d/1vdjTJMa7THVnircSwPC7svuVLbIRlUvT1JZBBVJ6-UU/edit#gid=621911183}
	     */

	  }, {
	    key: "reportPageView",
	    value: function reportPageView() {
	      this.integrate();

	      if (this.reportor && utils_3(this.reportor.reportPageView)) {
	        var _this$reportor3;

	        (_this$reportor3 = this.reportor).reportPageView.apply(_this$reportor3, arguments);
	      }
	    }
	  }]);

	  return Tdw;
	}();

	var IMLOG_TRACE_ID_KEY = 'IMLOG_TRACE_ID';
	/**
	 * 根据域名获取业务id，供全链路系统分表
	 * @param {string} host 主机名
	 * @ignore
	 */

	function getBizId(host) {
	  if (/ke\.qq\.com/.test(host)) {
	    return 'ke';
	  }

	  if (/fudao\.qq\.com/.test(host)) {
	    return 'k12';
	  }

	  return '';
	}
	/**
	 * 获取会话id
	 * @ingnore
	 */


	function getTraceId() {
	  try {
	    var sessionStorage = consts_7.sessionStorage;
	    var v = sessionStorage.getItem(IMLOG_TRACE_ID_KEY);

	    if (!v) {
	      v = uuid();
	      sessionStorage.setItem(IMLOG_TRACE_ID_KEY, v);
	    }

	    return v;
	  } catch (e) {
	    return uuid();
	  }
	}
	/**
	 * Model类，数据生成器
	 * @memberof @tencent/imlog/src/lib
	 */


	var Model =
	/*#__PURE__*/
	function () {
	  function Model() {
	    var initData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    _classCallCheck(this, Model);

	    var env = initData.env,
	        bizId = initData.bizId,
	        traceId = initData.traceId,
	        baseData = initData.baseData;
	    this.env = env || consts_7.ENV_NAME; // from nohost
	    // this.userAgent = Window.navigator && Window.navigator.userAgent;

	    this.bizId = bizId || getBizId(consts_7.location && consts_7.location.hostname);
	    this.traceId = traceId || getTraceId();
	    this.config(baseData);
	  }
	  /**
	   * 设置每个上报都应该合并的基础数据，比如: uin, project等
	   * @param {Object} data
	   * @param {(string|number)} data.xxx
	   */


	  _createClass(Model, [{
	    key: "config",
	    value: function config(data) {
	      this.baseData = Object.assign({}, this.baseData, data);
	    }
	  }, {
	    key: "common",
	    value: function common() {
	      var includeBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var base = includeBase ? this.baseData : {};
	      return _objectSpread({
	        env: this.env,
	        biz_id: this.bizId,
	        trace_id: this.traceId
	      }, base);
	    }
	    /**
	     * 统一生成数据接口
	     * @param {string|Object} type 类型或数据
	     * @param {Object} data 数据
	     * @return {Object} 一条上报数据
	     */

	  }, {
	    key: "generateRow",
	    value: function generateRow(type, data) {
	      if (utils_5(type)) {
	        data = type;
	        type = data.type;
	      } // 无效type类型


	      if (!consts_1[type]) {
	        return null;
	      }

	      var generator = this["".concat(type, "Generator")] || this.defaultGenerator;
	      var row = generator.call(this, data);
	      return _objectSpread({}, row, this.baseData, {
	        type: type,
	        log_timestamp: Date.now()
	      });
	    }
	  }, {
	    key: "".concat(consts_1.pageSpeed, "Generator"),
	    value: function value(data) {
	      // 补齐的字段处理
	      // http://dc.cp.oa.com/index.php/index/config?menu_id=01-02&rowid=8491
	      return _objectSpread({}, this.common(), data);
	    }
	  }, {
	    key: "defaultGenerator",
	    value: function defaultGenerator(data) {
	      // 补齐的字段处理
	      // http://dc.cp.oa.com/index.php/index/config?menu_id=01-02&rowid=8328
	      return _objectSpread({}, this.common(), data);
	    }
	  }]);

	  return Model;
	}(); // const BrowserModel = singletonify(Model);

	var aliasLog$1 = console;

	var noop$1 = function noop() {};

	aliasLog$1.group = aliasLog$1.group || noop$1;
	aliasLog$1.table = aliasLog$1.table || noop$1;
	aliasLog$1.groupEnd = aliasLog$1.groupEnd || noop$1;
	function writeConsole$1(tasks) {
	  var map = {};
	  tasks.forEach(function (task) {
	    var type = task.type;

	    if (!map[type]) {
	      map[type] = [];
	    }

	    map[type].push(task);
	  });
	  Object.entries(map).forEach(function (_ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        k = _ref2[0],
	        v = _ref2[1];

	    console.group(k);
	    console.table(v);
	    console.groupEnd();
	  });
	}

	var LocalStorage = consts_7.localStorage || {};
	/**
	 * 同构请求池
	 */

	var IS_STORAGE_SUPPORT = typeof LocalStorage.getItem === 'function';
	var STORAGE_KEY = 'IMLOG_POOL_CACHE'; // localStorage缓存key值

	/**
	 * Pool类 - 请求池用于合并上报，保证上报时机
	 * @memberof @tencent/imlog/src/lib
	 */

	var Pool =
	/*#__PURE__*/
	function (_EventEmitter) {
	  _inherits(Pool, _EventEmitter);

	  function Pool(options) {
	    var _this;

	    _classCallCheck(this, Pool);

	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pool).call(this));

	    _this.config(options);

	    _this.init();

	    return _this;
	  }
	  /**
	   * 配置请求池规则，如检测周期，最大合并条数等
	   * @param {Object} options
	   * @param {string} [options.url='//imweblog.qq.com/cgi-bin/log'] 上报CGI
	   * @param {number} [options.duration=500] 检测周期
	   * @param {number} [options.sizePerRequest=20] 最大合并条数
	   */


	  _createClass(Pool, [{
	    key: "config",
	    value: function config(options) {
	      // 多次config的情况this.options优先于defaultOpts
	      this.options = Object.assign({}, Pool.defaultOpts, this.options, options);
	    }
	  }, {
	    key: "init",
	    value: function init() {
	      var _this2 = this;

	      this.tasks = [];
	      this.wrapData = {};
	      this.check();
	      this.ensure(); // 延后让外层初始化监听事件

	      setTimeout(function () {
	        return _this2.recover();
	      });
	    }
	  }, {
	    key: "check",
	    value: function check() {
	      var _this3 = this;

	      var duration = this.options.duration;

	      if (!this.timer) {
	        this.timer = setTimeout(function () {
	          _this3.timer = null;

	          _this3.check();

	          if (_this3.tasks.length) {
	            _this3.report();
	          }
	        }, duration);
	      }
	    }
	  }, {
	    key: "ensure",
	    value: function ensure() {
	      var _this4 = this;

	      consts_7.addEventListener('beforeunload', function () {
	        if (!navigator.sendBeacon) {
	          _this4.stash();

	          return;
	        }

	        if (!_this4.tasks.length) {
	          return;
	        } // Beacon保证请求发送，暂不考虑服务返回失败的可能


	        var data = _this4.pack();

	        navigator.sendBeacon(_this4.options.url, "data=".concat(stringify(data)));
	      });
	    }
	  }, {
	    key: "destory",
	    value: function destory() {
	      if (this.timer) {
	        clearTimeout(this.timer);
	      }
	    }
	    /**
	     * 添加一条上报数据到请求池中
	     * @param {Object} data 上报数据
	     */

	  }, {
	    key: "add",
	    value: function add(data) {
	      if (!data) {
	        return;
	      }

	      if (!data.project) {
	        console.warn('[IMLOG]该条日志因未配置project字段被丢弃', data);
	        return;
	      }

	      this.tasks.push(data);
	    }
	  }, {
	    key: "recover",
	    value: function recover() {
	      var _this5 = this;

	      if (!IS_STORAGE_SUPPORT) {
	        return;
	      }

	      var s;

	      try {
	        s = LocalStorage.getItem(STORAGE_KEY);
	        LocalStorage.removeItem(STORAGE_KEY);

	        if (typeof s === 'string' && s) {
	          var tasks = JSON.parse(s);

	          if (utils_6(tasks) && tasks.length) {
	            tasks.forEach(function (task) {
	              return _this5.add(task);
	            });
	          }
	        }
	      } catch (e) {
	        this.emit('recovererror', e, s);
	      }
	    }
	  }, {
	    key: "stash",
	    value: function stash() {
	      if (!IS_STORAGE_SUPPORT) {
	        return;
	      }

	      try {
	        LocalStorage.setItem(STORAGE_KEY, stringify(this.tasks));
	        this.tasks = [];
	      } catch (e) {
	        this.emit('stasherror', e);
	      }
	    }
	    /**
	     * 设置打包时的外层公共数据
	     */

	  }, {
	    key: "wrap",
	    value: function wrap(o) {
	      this.wrapData = o;
	    }
	  }, {
	    key: "pack",
	    value: function pack() {
	      var sizePerRequest = this.options.sizePerRequest;
	      var tasks = this.tasks.splice(0, sizePerRequest);

	      if (consts_7.ENV_NAME !== 'production') {
	        writeConsole$1(tasks);
	      }

	      return {
	        tasks: tasks,
	        data: _objectSpread({}, this.wrapData, {
	          url: this.options.href || consts_7.location.href,
	          list: tasks.map(function (v) {
	            return utils_13(v);
	          })
	        })
	      };
	    }
	  }, {
	    key: "report",
	    value: function report(ignoreFail) {
	      var _this6 = this;

	      var _loop = function _loop() {
	        var _this6$pack = _this6.pack(),
	            data = _this6$pack.data;

	        fetch(_this6.options.url, {
	          method: 'POST',
	          credentials: 'include',
	          headers: {
	            // 避免preflight请求
	            'Content-Type': 'text/plain'
	          },
	          body: stringify(data)
	        }).then(function (res) {
	          if (res.ok) {
	            return res.json();
	          }

	          return Promise.reject(res);
	        }).then(function (json) {
	          if (json.ec !== 0) {
	            return Promise.reject(new Error("ec\u8FD4\u56DE\u9519\u8BEF".concat(data.ec)));
	          }
	        })["catch"](function (e) {
	          if (!ignoreFail) {
	            _this6.emit('reporterror', e, data.list);
	          } // 下一周期重试
	          // this.tasks.push(...tasks);

	        });
	      };

	      while (this.tasks.length) {
	        _loop();
	      }
	    }
	  }]);

	  return Pool;
	}(EventEmitter); // const BrowserPool = singletonify(Pool);


	_defineProperty(Pool, "defaultOpts", {
	  // 上报CGI
	  // 必须https，STGW配了http->https的307跳转没有跨域头
	  url: 'https://imweblog.qq.com/cgi-bin/log',
	  // 上报数据地址
	  // 为Cocos，小程序等无location.href的环境自定义配置
	  href: undefined,
	  // 上报检测周期
	  duration: 500,
	  // 有效时长
	  validPeriod: 3600 * 24 * 12,
	  // 一次上报数据量
	  sizePerRequest: 20
	});

	/**
	 * Reportor类 - 集成所有上报模块并暴露接口
	 * @memberof @tencent/imlog
	 * @mixes {LogInterfaces}
	 */

	var Reportor =
	/*#__PURE__*/
	function () {
	  // channel -> Logger实例
	  // channel -> Reportor实例
	  function Reportor() {
	    _classCallCheck(this, Reportor);

	    this.strategies = {};

	    if (utils_8) {
	      return;
	    }

	    this.strategies = {
	      model: new Model(),
	      pool: new Pool(),
	      network: new BrowserNetwork()
	    };
	    this._monitor = new Monitor(this.strategies);
	    this._speed = new Speed(this.strategies);
	    this._tdw = new Tdw(this.strategies);
	    this._logger = new BrowserLogger('imlog', this.strategies);
	    this.listenErrors();
	    Reportor.reportorMap.imlog = this;
	    Reportor.loggerMap.imlog = this._logger;
	  }

	  _createClass(Reportor, [{
	    key: "listenErrors",
	    value: function listenErrors() {
	      var _this = this;

	      if (utils_8 || this.isListeningErrors) {
	        return;
	      }

	      this.isListeningErrors = true;
	      var pool = this.strategies.pool;
	      ['recovererror', 'stasherror'].forEach(function (eventName) {
	        pool.on(eventName, function (e, s) {
	          _this._logger.error(e.message, {
	            // 限制有点严格呀
	            project: 'imlog',
	            addition: s,
	            monitor_id: "imlog-".concat(eventName)
	          }); // 立即上报，beforeunload的时机是否上报成功看缘分了


	          pool.report(true);
	        });
	      });
	      pool.on('reporterror', function (e) {
	        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	        _this._logger.error(e.message, {
	          project: 'imlog',
	          monitor_id: 'imlog-reporterror',
	          monitor_count: data.length
	        }); // 立即上报，此次必须忽略错误，否则可能会有无限上报循环


	        pool.report(true);
	      });
	    }
	    /**
	     * 统一配置
	     * @param {Object} data 完整配置
	     * @param {Object} data.tdw tdw行为模块相关配置{@link Reportor#configTdw}
	     * @param {Object} data.speed speed测速模块相关配置{@link Reportor#configSpeed}
	     * @param {Object} data.logger logger日志模块相关配置{@link Reportor#configLogger}
	     * @param {Object} data.pool 请求池相关配置{@link Reportor#configPool}
	     * @param {Object} data.network 网络抓取相关配置{@link Reportor#configNetwork}
	     * @param {(string|number)} data.xxx 全局上报字段如project, uin{@link Reportor#configModel}
	     */

	  }, {
	    key: "config",
	    value: function config(data) {
	      var tdw = data.tdw,
	          speed = data.speed,
	          logger = data.logger,
	          pool = data.pool,
	          network = data.network,
	          rest = _objectWithoutProperties(data, ["tdw", "speed", "logger", "pool", "network"]); // 全局数据配置


	      this.configModel(rest); // 上报池配置

	      this.configPool(pool); // 请求抓取配置

	      this.configNetwork(network); // tdw相关配置

	      this.configTdw(tdw); // 测速相关配置

	      this.configSpeed(speed); // 日志相关配置

	      this.configLogger(logger);
	    }
	    /**
	     * 配置全局上报字段
	     * @param {Object} [options={}] 属性需符合{@link http://dc.cp.oa.com/index.php/index/config?menu_id=01-02&rowid=8491|DC表字段}
	     */

	  }, {
	    key: "configModel",
	    value: function configModel() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var model = this.strategies.model;

	      if (model) {
	        model.config(options);
	      }
	    }
	    /**
	     * 配置请求池
	     * @param {Object} [options={}] 请求池相关配置{@link Pool#config}
	     */

	  }, {
	    key: "configPool",
	    value: function configPool() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var _this$strategies = this.strategies,
	          model = _this$strategies.model,
	          pool = _this$strategies.pool;

	      if (pool) {
	        pool.config(options);
	        pool.wrap(model.common(true));
	      }
	    }
	    /**
	     * 配置网络抓取
	     * @param {Object} [options={}] 网络抓取相关配置{@link Network#config}
	     */

	  }, {
	    key: "configNetwork",
	    value: function configNetwork() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var network = this.strategies.network;

	      if (network) {
	        network.config(options);
	      }
	    }
	    /**
	     * 配置tdw
	     * @param {Object} [options={}] tdw相关配置{@link Tdw#config}
	     */

	  }, {
	    key: "configTdw",
	    value: function configTdw() {
	      if (this._tdw) {
	        var _this$_tdw;

	        (_this$_tdw = this._tdw).config.apply(_this$_tdw, arguments);
	      }
	    }
	    /**
	     * 配置speed
	     * @param {Object} [options={}] speed相关配置{@link Speed#config}
	     */

	  }, {
	    key: "configSpeed",
	    value: function configSpeed() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      if (this._speed) {
	        this._speed.config(options);
	      }
	    }
	    /**
	     * 配置logger
	     * @param {Object} [options={}] logger相关配置{@link Logger#config}
	     */

	  }, {
	    key: "configLogger",
	    value: function configLogger() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	      if (this._logger) {
	        this._logger.config(options);
	      }
	    }
	    /**
	     * 创建新的Logger实例
	     * @example
	     * // 创建channel为h5pay的日志logger
	     * const logger = imLog.createLogger('h5pay');
	     * // 打印各种级别的日志
	     * logger.trace('test');
	     * logger.info('test');
	     * logger.warn('test');
	     * logger.debug('test');
	     * logger.error('test');
	     * logger.fatal('test');
	     * @param {string} channel 频道{@link Logger}
	     */

	  }, {
	    key: "createLogger",
	    value: function createLogger(channel) {
	      if (utils_8) {
	        return {};
	      }

	      var logger = Reportor.loggerMap[channel];

	      if (!logger) {
	        logger = new BrowserLogger(channel, this.strategies);
	        Reportor.loggerMap[channel] = logger;
	      }

	      return logger;
	    }
	    /**
	     * 创建新的Reportor实例
	     * @example
	     * // 创建channel为h5pay的reportor
	     * const reportor = imLog.createReportor('h5pay');
	     * // 打印各种级别的日志及使用monitor等API
	     * reportor.pv('payclk');
	     * reportor.info('payclk')
	     * @param {string} channel 频道{@link Logger}
	     */

	  }, {
	    key: "createReportor",
	    value: function createReportor(channel) {
	      if (utils_8) {
	        return {};
	      }

	      var reportor = Reportor.reportorMap[channel];

	      if (!reportor) {
	        reportor = Object.create(Reportor.reportorMap.imlog);
	        reportor.strategies = _objectSpread({}, this.strategies, {
	          // createReportor单独策略
	          model: new Model({
	            baseData: this.strategies.model.baseData
	          }),
	          pool: new Pool()
	        });
	        reportor._logger = reportor.createLogger(channel);
	        Reportor.reportorMap[channel] = reportor;
	      }

	      return reportor;
	    }
	    /**
	     * 全自定义上报，无字段限制
	     * @example
	     * imlog.raw({
	     *   message: 'xxx',
	     *   channel: 'xxx',
	     *   trace_id: 'xxx',
	     *   cmd: 'xxx',
	     *   status_code: 0,
	     *   retcode: 0,
	     *   cost_time: 1,
	     *   service_ip: 'xxx',
	     *   query: 'xxx',
	     *   level: LEVELS.info,
	     *   monitor_id: 'xxx',
	     *   monitor_count: 1,
	     *   platform: 1,
	     *   env: 'xxx',
	     * });
	     */

	  }, {
	    key: "raw",
	    value: function raw(data) {
	      var _this$strategies2 = this.strategies,
	          model = _this$strategies2.model,
	          pool = _this$strategies2.pool;
	      var commonData = model ? model.common(true) : {};

	      var row = _objectSpread({}, commonData, utils_16(data));

	      if (pool) {
	        pool.add(row);
	      }
	    }
	  }]);

	  return Reportor;
	}();

	_defineProperty(Reportor, "loggerMap", {});

	_defineProperty(Reportor, "reportorMap", {});

	var interfaces = {
	  _monitor: ['pv', 'monitor'],
	  _tdw: ['tdw', 'reportPageView'],
	  _speed: ['speed', 'speedOnlyForward', 'pageSpeed', 'pageRenderFp', 'pageRenderEnd'],
	  _logger: ['prefix', 'extra', 'debug', 'info', 'warn', 'error', 'fatal', 'trace', 'clear', 'keep', 'autoUpload', 'autoCollect', 'upload']
	};
	Object.entries(interfaces).forEach(function (_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      name = _ref2[0],
	      methods = _ref2[1];

	  methods.forEach(function (method) {
	    Reportor.prototype[method] = function () {
	      if (utils_8) {
	        return this;
	      }

	      if (this[name]) {
	        var _this$name;

	        return (_this$name = this[name])[method].apply(_this$name, arguments) || this;
	      }

	      console.error("[IMLOG]".concat(method, "\u65B9\u6CD5\u672A\u91CD\u8F7D"));
	      return this;
	    };
	  });
	});
	var BrowserReportor = utils_10(Reportor);
	var browser = new BrowserReportor();

	exports.LEVELS = LEVELS;
	exports.default = browser;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
